<template>
  <div class="choose-enterprise-page">
    <van-nav-bar
      title="选择企业"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="page-content">
      <div class="search-section">
        <!-- <van-search
          v-model="searchKeyword"
          show-action
          placeholder="输入企业名称/信用代码搜索企业"
          @search="onSearch"
          @clear="onClear"
        >
         <template #action>
            <div @click="onSearch">搜索</div>
          </template></van-search
        > -->
        <div class="search-prompt">
          <a
            href="#"
            @click.prevent="addNewEnterprise"
            class="add-enterprise-link"
          >
            点击新增企业
          </a>
        </div>
      </div>

      <div class="results-section">
        <div v-if="searching" class="loading-wrap">
          <van-loading type="spinner" size="24px">加载中...</van-loading>
        </div>

        <div v-else-if="searchResults.length > 0" class="enterprise-list">
          <div
            v-for="(enterprise, index) in searchResults"
            :key="index"
            class="enterprise-item"
            :class="{
              active:
                selectedEnterprise && selectedEnterprise.id == enterprise.id,
            }"
            @click="selectEnterprise(enterprise)"
          >
            <div
              class="check-icon"
              v-if="
                selectedEnterprise && selectedEnterprise.id == enterprise.id
              "
            >
              <van-icon name="checked" size="18" color="#1890ff" />
            </div>
            <div class="enterprise-info">
              <div class="enterprise-name">{{ enterprise.name }}</div>
              <div class="enterprise-code">
                {{ enterprise.socialCreditCode }}
              </div>
            </div>
            <div class="editor-icon">
              <van-icon
                name="edit"
                @click.stop="editEnterprise(enterprise)"
                style="margin-right: 12px"
                size="18"
                color="#1890ff"
              />
              <van-icon
                name="delete-o"
                @click.stop="detleteEnterprise(enterprise)"
                size="18"
                color="#1890ff"
              />
            </div>
          </div>
        </div>

        <!-- <div v-else-if="hasSearched" class="no-results">
          <div class="no-results-content">
            <p class="no-results-text">未搜索到相关企业？</p>
            <a
              href="#"
              @click.prevent="addNewEnterprise"
              class="add-enterprise-link"
            >
              点击新增企业
            </a>
          </div>
        </div> -->

        <!-- <div v-else class="search-prompt">
          <a
            href="#"
            @click.prevent="addNewEnterprise"
            class="add-enterprise-link"
          >
            点击新增企业
          </a>
        </div> -->
      </div>

      <div class="confirm-section">
        <van-button
          v-if="selectedEnterprise"
          type="primary"
          size="large"
          round
          @click="confirmSelection"
          class="confirm-button"
        >
          确定
        </van-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Toast, Dialog } from "vant";
import { get, put, deletes } from "@/request.js";
import { debounce } from "@/utils";

const router = useRouter();
const route = useRoute();

const searchKeyword = ref("");
const hasSearched = ref(false);
const searchResults = ref([]);
const searching = ref(false);
const selectedEnterprise = ref(null);
const courseId = ref("");
// 方法
const onClickLeft = () => {
  router.back();
};
const onClear = () => {
  searchResults.value = [];
  hasSearched.value = false;
  selectedEnterprise.value = null;
};
// const onInputSearch = debounce(async function (e) {
//   console.log(e);
// }, 500);
const onSearch = async () => {
  hasSearched.value = true;
  searching.value = true;
  try {
    const res = await get("/api/my/companies/search", {
      keyword: searchKeyword.value,
    });
    if (res && res.success) {
      searchResults.value = res.data || [];
    } else {
      searchResults.value = [];
    }
  } catch (err) {
    searchResults.value = [];
  } finally {
    searching.value = false;
  }
};

// 选择企业
const selectEnterprise = (enterprise) => {
  selectedEnterprise.value = enterprise;
};

// 新增企业
const addNewEnterprise = () => {
  router.push({
    path: "/addEnterprise",
    query: { courseId: courseId.value, id: "", isEdit: 0 },
  });
};

const confirmSelection = async () => {
  if (!selectedEnterprise.value) {
    Toast("请选择企业");
    return;
  }
  const res = await put(
    `/api/my/registration/company/${courseId.value}?companyId=${selectedEnterprise.value.id}`
  );
  if (res.success) {
    Toast("操作成功");
    setTimeout(() => {
      router.back();
    }, 1000);
  }
};
const editEnterprise = (enterprise) => {
  router.push({
    path: "/addEnterprise",
    query: { id: enterprise.id, isEdit: 1, courseId: courseId.value },
  });
};
const detleteEnterprise = (enterprise) => {
  Dialog.confirm({
    title: "确认删除",
    message: "确定要删除该企业吗？",
  }).then(async () => {
    console.log(enterprise.id);
    if (selectedEnterprise.value.id == enterprise.id) {
      selectedEnterprise.value = null;
    }
    const res = await deletes(`/api//my/companies/${enterprise.id}`);
    if (res.success) {
      Toast("操作成功");
      setTimeout(() => {
        onSearch();
      }, 300);
    }
  });
};

onMounted(async () => {
  courseId.value = route.query.courseId || "";
  await onSearch();
  const fromEnterprise = JSON.parse(localStorage.getItem("fromEnterprise"));
  if (fromEnterprise) {
    localStorage.removeItem("fromEnterprise");
    if (fromEnterprise.refresh) {
      selectedEnterprise.value = { id: fromEnterprise.companyId } || null;
    }
  }
});
</script>

<style scoped lang="less">
.choose-enterprise-page {
  min-height: 100vh;
}

.page-content {
  padding: 10px 16px;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 46px);
  .search-prompt {
    text-align: center;
    padding: 10px 20px;
    color: #1890ff;
    font-size: 16px;
  }
  .add-enterprise-link {
    color: #1890ff;
    font-size: 16px;
    text-decoration: none;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
}

.search-section {
  margin-bottom: 20px;
  :deep(.van-search__content) {
    padding: 8px;
  }
  :deep(.van-search__action) {
    font-size: 16px !important;
  }
  :deep(.van-search__placeholder) {
    font-size: 16px !important;
  }
}

.results-section {
  flex: 1;
  overflow-y: auto;
  .loading-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .enterprise-list {
    .enterprise-item {
      background: white;
      border-radius: 8px;
      padding: 16px;
      margin-bottom: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      transition: all 0.3s ease;
      border: 2px solid transparent;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      &.active {
        border-color: #1890ff;
        box-shadow: 0 2px 12px rgba(24, 144, 255, 0.3);
      }

      .enterprise-info {
        flex: 1;

        .enterprise-name {
          font-size: 16px;
          font-weight: 500;
          color: #333;
          margin-bottom: 4px;
        }

        .enterprise-code {
          font-size: 14px;
          color: #666;
          margin-top: 10px;
        }
      }

      .check-icon {
        margin-right: 12px;
      }
      .editor-icon {
        margin-left: 12px;
      }
    }
  }

  .no-results {
    text-align: center;
    padding: 60px 20px;

    .no-results-content {
      .no-results-text {
        font-size: 16px;
        color: #666;
        margin-bottom: 16px;
      }

      .add-enterprise-link {
        color: #1890ff;
        font-size: 16px;
        text-decoration: none;
        font-weight: 500;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}

.confirm-section {
  margin-top: 20px;
  padding-bottom: 20px;

  .confirm-button {
    width: 100%;
    height: 50px;
    font-size: 16px;
    font-weight: 600;
    background: linear-gradient(135deg, #1890ff, #36cfc9);
    border: none;
  }
}
</style>
